<div class="confirmation-checkbox-field">
  <button
    type="button"
    class="confirmation-checkbox"
    [class.confirmation-checkbox-invalid]="isInvalid"
    [id]="id"
    [attr.aria-pressed]="control?.value === true"
    [attr.aria-required]="required"
    [attr.aria-invalid]="isInvalid"
    [attr.aria-describedby]="isInvalid ? errorId : null"
    (click)="toggle()"
  >
    <span
      class="confirmation-checkbox-box"
      [class.checked]="control?.value === true"
    ></span>
    <span class="confirmation-checkbox-label">{{ label }}</span>
  </button>
  <p [id]="errorId" class="confirmation-checkbox-error" *ngIf="isInvalid">
    {{ errorText }}
  </p>
</div>
